module.exports = __webpack_public_path__ + "img/registration-step1.b741a7dc.png";